import { isPatrolmanPlusSku, isReconRelaySku } from "../configuration-sku-family.js";

/** Dome O-ring stocked at Final QC (station 9) via manufacturing.station_stock. */
export const FINAL_QC_DOME_O_RING_SKU = "88-007-DM-01";

/** Wireless dome O-ring stocked at Final QC (station 9) via manufacturing.station_stock. */
export const FINAL_QC_WIRELESS_DOME_O_RING_SKU = "88-007-W-01";

export function isFinalQcORingStationStockSku(skuRaw: string): boolean {
  const normalized = skuRaw.trim().toLowerCase();
  return (
    normalized === FINAL_QC_DOME_O_RING_SKU.toLowerCase() ||
    normalized === FINAL_QC_WIRELESS_DOME_O_RING_SKU.toLowerCase()
  );
}

/** Map a Recon Relay (DM-1*) finished SKU to the dome O-ring consumed on Final QC grade. */
export function resolveFinalQcDomeORingSku(finishedSkuRaw: string): string | null {
  const finishedSku = finishedSkuRaw.trim();
  if (finishedSku === "") return null;
  if (isReconRelaySku(finishedSku)) return FINAL_QC_DOME_O_RING_SKU;
  return null;
}

/** Map a Patrolman Plus (FI-5A-W*) finished SKU to the wireless dome O-ring consumed on Final QC grade. */
export function resolveFinalQcWirelessDomeORingSku(finishedSkuRaw: string): string | null {
  const finishedSku = finishedSkuRaw.trim();
  if (finishedSku === "") return null;
  if (isPatrolmanPlusSku(finishedSku)) return FINAL_QC_WIRELESS_DOME_O_RING_SKU;
  return null;
}
